import colors from 'common/styles/colors';

export const NTN_PRIMARY_COLOR = 'rgb(0, 131, 202)';
export const PETASENSE_PRIMARY_TEXT_COLOR = colors.greenD;
export const NTN_PRIMARY_TEXT_COLOR = NTN_PRIMARY_COLOR;

export const BRAND_IDS = {
  PETASENSE: 'petasense',
  NTN: 'ntn',
};

export const companyData = {
  Petasense: {
    name: 'Petasense',
    productName: 'ARO',
    corporation: 'Petasense Inc',
    logo: '',
    theme: {
      brandId: BRAND_IDS.PETASENSE,
      primaryColor: colors.green,
      primaryTextColor: PETASENSE_PRIMARY_TEXT_COLOR,
      secondaryColor: '#a6d69f',
      backgroundColor: '#EDF3E1',
      grey: '#999B95',
      backgroundA: a => `rgba(145, 184, 70, ${a})`,
      hoverTintBg: '#f3f5ef',
      badgeBackground: '#eef3e1',
      badgeColor: '#4f7a16',
      searchInputBorder: '#9bbb5f',
      templateBannerTitleColor: PETASENSE_PRIMARY_TEXT_COLOR,
      costSavedHighlightBg: '#F0F5E6',
      costSavedHighlightBorder: '#C5D9A0',
      costSavedHighlightShadow: 'rgba(106, 155, 36, 0.25)',
    },
    title: 'Petasense ARO Webapp',
    urlKey: 'petasense'
  },
  ntn: {
    name: 'NTN',
    productName: 'Guardian',
    corporation: 'NTN Bearing Corporation of America',
    logo: '',
    theme: {
      brandId: BRAND_IDS.NTN,
      primaryColor: NTN_PRIMARY_COLOR,
      primaryTextColor: NTN_PRIMARY_TEXT_COLOR,
      secondaryColor: '#acdde8',
      backgroundColor: '#e4f4f7',
      grey: '#7f8a88',
      backgroundA: a => `rgb(0, 131, 202, ${a})`,
      hoverTintBg: '#F8FAFC',
      badgeBackground: '#e4f4f7',
      badgeColor: NTN_PRIMARY_COLOR,
      searchInputBorder: '#acdde8',
      templateBannerTitleColor: '#111827',
      costSavedHighlightBg: '#EDF6FD',
      costSavedHighlightBorder: '#B7D8EE',
      costSavedHighlightShadow: 'rgba(0, 131, 202, 0.25)',
    },
    title: 'NTN',
    urlKey: 'ntnguardian'
  },
};

export const getActivePartnerBasedOnDomain = () => {
  const fullHostName = window.location.hostname;
  const lowerCaseHostName = fullHostName.toLowerCase();
  let partner;
  if (lowerCaseHostName.includes('ntn')) {
    partner = companyData.ntn;
  } else {
    partner = companyData.Petasense;
  }


  // getBaseUrl() calls this at module scope, so any module that transitively
  // imports common/constants runs it on load. Without this guard a document
  // with no favicon link (jsdom, tests, an embedded host page) throws before a
  // single line of app code executes.
  const link = document.querySelector('link[rel="icon"]');
  if (link) {
    link.setAttribute('href', partner.name === 'NTN' ? '/favicon-ntn.ico' : '/favicon.ico');
  }

  return partner;
};

export const getBaseUrl = () => {
  const partner = getActivePartnerBasedOnDomain();
  let url = process.env.REACT_APP_BASE_URL;
  // The ntnguardian domain only exists in production. For local dev the
  // backend is always served from the petasense domain (e.g.
  // petasense.dev.me:5000), even when the frontend is opened via an
  // ntn.dev.me URL, so only rewrite the host outside of local dev.
  const isLocalDev = url && url.includes('dev.me');
  if (partner.name !== 'Petasense' && !isLocalDev) {
    url = url.replace(companyData.Petasense.urlKey, partner.urlKey);
  }
  return url;
};
